import { Link } from 'react-router';
import theme from '@/constants/theme';
import { ArrowBack } from '@mui/icons-material';
import React from 'react';
import HeaderNavigationPlaceholder from './placeholder';

interface Props {
  title: string;
  backHref: string;
  rightContent?: React.ReactNode;
  loading?: boolean;
}

const HeaderNavigation: React.FC<Props> = ({ title, backHref, rightContent, loading }) => {
  if (loading === true) return <HeaderNavigationPlaceholder />;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        position: 'sticky',
        top: '0px',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 16,
        backgroundColor: theme.colors.background.primary,
        color: theme.colors.text.default,
        zIndex: 1000,
        gap: 16,
      }}
    >
      <Link
        to={backHref}
        style={{
          backgroundColor: 'inherit',
          color: 'inherit',
          border: 'none',
        }}
      >
        <ArrowBack />
      </Link>
      <h3
        style={{
          color: theme.colors.text.title,
          fontSize: 16,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {title}
      </h3>
      {rightContent ? rightContent : <span style={{ padding: 16 }}></span>}
    </div>
  );
};

export default HeaderNavigation;
